import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";
import DashboardLayout from "src/pages/Layout/DashboardLayout.vue";
// GeneralViews
import AuthLayout from "src/pages/Pages/AuthLayout.vue";
// Calendar
const Calendar = () =>
  import(
    /* webpackChunkName: "extra" */ "src/pages/Calendar/CalendarRoute.vue"
  );
// Charts
const Charts = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Charts.vue");
// Components pages
const Buttons = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Buttons.vue"
  );
const GridSystem = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/GridSystem.vue"
  );
const Panels = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Panels.vue"
  );
const SweetAlert = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/SweetAlert.vue"
  );
const Notifications = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Notifications.vue"
  );
const Icons = () =>
  import(/* webpackChunkName: "components" */ "src/pages/Components/Icons.vue");
const Typography = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Typography.vue"
  );
// Dashboard pages
const Dashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard.vue"
  );
import Widgets from "src/pages/Widgets.vue";

// Forms pages
const RegularForms = () => import("src/pages/Forms/RegularForms.vue");
const ExtendedForms = () => import("src/pages/Forms/ExtendedForms.vue");
const ValidationForms = () => import("src/pages/Forms/ValidationForms.vue");
const Wizard = () => import("src/pages/Forms/Wizard.vue");

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "extra" */ "src/pages/Maps/GoogleMaps.vue");
const FullScreenMap = () =>
  import(/* webpackChunkName: "extra" */ "src/pages/Maps/FullScreenMap.vue");
const VectorMaps = () =>
  import(/* webpackChunkName: "extra" */ "src/pages/Maps/VectorMaps.vue");

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/UserProfile.vue");
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Pricing.vue");
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/TimeLinePage.vue");
const Login = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Login.vue");
const DeleteAccount = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/DeleteAccount.vue");
const Logout = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Logout.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Register.vue");
const RTL = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/RTLPage.vue");
const Lock = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Lock.vue");
const PublicCmsPage = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/CMS/PublicPage.vue");

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Tables/RegularTables.vue");
const ExtendedTables = () =>
  import(
    /* webpackChunkName: "tables" */ "src/pages/Tables/ExtendedTables.vue"
  );
const PaginatedTables = () =>
  import(
    /* webpackChunkName: "tables" */ "src/pages/Tables/PaginatedTables.vue"
  );
let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography }
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Paginated Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: User }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    {
      path: "rtl",
      name: "RTL Page",
      components: { default: RTL }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/delete-account",
      name: "delete-account",
      component: DeleteAccount,
      meta: {
        public: true
      }
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout
    },
    {
      path: "/register",
      name: "Register",
      component: Register
    },
    {
      path: "/pricing",
      name: "Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Lock",
      component: Lock
    }
  ]
};

const EventsTableList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Events/TableList.vue");
const EventsList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Events/List.vue");
const EventsEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Events/Edit.vue");

const EventsOrganizer = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Events/Organizer.vue");

const EventsBookings = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Events/User_booking.vue");

let events = {
  path: "/events",
  component: DashboardLayout,
  redirect: "/events/list",
  name: "Events",
  children: [
    {
      path: "list",
      name: "Events List",
      components: { default: EventsList }
    },
    {
      path: "list-table",
      name: "Events List Table",
      components: { default: EventsTableList }
    },
    {
      path: "edit",
      name: "Edit Event",
      components: { default: EventsEdit }
    },
    {
      path: "add",
      name: "Add Event",
      components: { default: EventsEdit }
    },

    {
      path: "organizer",
      name: "assign organizer",
      components: { default: EventsOrganizer }
    },

    {
      path: "bookings",
      name: "Bookings",
      components: { default: EventsBookings }
    }
  ]
};

const PassesList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Passes/List.vue");
const PassesEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Passes/Edit.vue");
const PassesEnvironment = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Passes/Environment.vue");

let passes = {
  path: "/passes",
  component: DashboardLayout,
  redirect: "/passes/list",
  name: "Passes",
  children: [
    {
      path: "list",
      name: "Passes List",
      components: { default: PassesList }
    },
    {
      path: "edit",
      name: "Edit Pass",
      components: { default: PassesEdit }
    },
    {
      path: "add",
      name: "Add Pass",
      components: { default: PassesEdit }
    },
    {
      path: "types",
      name: "Edit Pass Types",
      components: { default: PassesEnvironment }
    }
  ]
};

const ImagesList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Images/List.vue");
const ImagesEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Images/Edit.vue");

let images = {
  path: "/images",
  component: DashboardLayout,
  redirect: "/images/list",
  name: "Images",
  children: [
    {
      path: "list",
      name: "Images List",
      components: { default: ImagesList }
    },
    {
      path: "edit",
      name: "Edit Images",
      components: { default: ImagesEdit }
    },
    {
      path: "add",
      name: "Add Images",
      components: { default: ImagesEdit }
    }
  ]
};

const UsersList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Users/List.vue");

const UsersEdit = () => import("src/pages/Users/EditUser.vue");

const ContactMessagesList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/ContactMessages/List.vue");
const ContactMessagesEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/ContactMessages/Edit.vue");

const SupportV2List = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/SupportV2/List.vue");
const SupportV2Edit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/SupportV2/Edit.vue");

const EventChatList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/EventChat/List.vue");
const EventChatRoom = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/EventChat/Room.vue");

let users = {
  path: "/users",
  component: DashboardLayout,
  redirect: "/users/list",
  name: "Users",
  children: [
    {
      path: "list",
      name: "Users List",
      components: { default: UsersList }
    },
    {
      path: "edit-user",
      name: "Edit User",
      components: { default: UsersEdit }
    }
  ]
};

let contactMessages = {
  path: "/support_queries",
  component: DashboardLayout,
  redirect: "/support_queries/list",
  name: "Support Queries",
  children: [
    {
      path: "list",
      name: "Support Queries",
      components: { default: ContactMessagesList }
    },
    {
      path: "edit-support_query",
      name: "View Support Query",
      components: { default: ContactMessagesEdit }
    }
  ]
};

let supportV2 = {
  path: "/support_v2",
  component: DashboardLayout,
  redirect: "/support_v2/list",
  name: "Support V2",
  children: [
    {
      path: "list",
      name: "Support V2 List",
      components: { default: SupportV2List }
    },
    {
      path: "edit",
      name: "View Support V2 Query",
      components: { default: SupportV2Edit }
    }
  ]
};

let eventChat = {
  path: "/event_chat",
  component: DashboardLayout,
  redirect: "/event_chat/list",
  name: "Event Chat",
  children: [
    {
      path: "list",
      name: "Event Chat List",
      components: { default: EventChatList }
    },
    {
      path: "room",
      name: "Event Chat Room",
      components: { default: EventChatRoom }
    }
  ]
};




const VaccinesList = () => import("src/pages/vaccinations/List.vue");
const VaccinesEdit = () => import("src/pages/vaccinations/Edit.vue");


let vaccinations = {
  path: "/vaccinations",
  component: DashboardLayout,
  redirect: "/vaccinations/list",
  name: "Vaccinations",
  children: [
    {
      path: "list",
      name: "Pending Vaccinations",
      components: { default: VaccinesList }
    },
    {
      path: "edit-user-vaccination",
      name: "Edit User",
      components: { default: VaccinesEdit }
    }
  ]
}

// Phase 1 — Task 3C: admin page for host applications submitted from the user app
const HostApplicationsList = () => import("src/pages/HostApplications/List.vue");
let hostApplications = {
  path: "/hostapplications",
  component: DashboardLayout,
  redirect: "/hostapplications/list",
  name: "Host Applications",
  children: [
    { path: "list", name: "Host Applications", components: { default: HostApplicationsList } },
  ],
};

const EventOrganizersList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Organizers/List.vue");
const EventOrganizersEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Organizers/Edit.vue");
const EventOrganizersEvent = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Organizers/Event.vue");

let eventOrganizer = {
  path: "/organizers",
  component: DashboardLayout,
  redirect: "/organizers/list",
  name: "Organizers",
  children: [
    {
      path: "list",
      name: "Event Organizers List",
      components: { default: EventOrganizersList }
    },

    {
      path: "add",
      name: "Add Event Organizers",
      components: { default: EventOrganizersEdit }
    },

    {
      path: "event",
      name: "Add Event Organizers",
      components: { default: EventOrganizersEvent }
    }
  ]
};

const CityList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/City/List.vue");
const CityEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/City/Edit.vue");
const SportsList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Sports/List.vue");
const SportsEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Sports/Edit.vue");

let city = {
  path: "/city",
  component: DashboardLayout,
  redirect: "/city/list",
  name: "Cities",
  children: [
    {
      path: "list",
      name: "City List",
      components: { default: CityList }
    },

    {
      path: "add",
      name: "Add City",
      components: { default: CityEdit }
    }
  ]
};

let sports = {
  path: "/sports",
  component: DashboardLayout,
  redirect: "/sports/list",
  name: "Sports",
  children: [
    {
      path: "list",
      name: "Sports List",
      components: { default: SportsList }
    },
    {
      path: "add",
      name: "Add Sport",
      components: { default: SportsEdit }
    },
    {
      path: "edit",
      name: "Edit Sport",
      components: { default: SportsEdit }
    }
  ]
};

const BookingsList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Bookings/List.vue");

let bookings = {
  path: "/bookings",
  component: DashboardLayout,
  redirect: "/bookings/list",
  name: "Bookings",
  children: [
    {
      path: "list",
      name: "Bookings List",
      components: { default: BookingsList }
    }
  ]
};

const MessageList = () =>   import(/* webpackChunkName: "pages" */ "src/pages/Messages/List.vue");
const MessageSend = () =>   import(/* webpackChunkName: "pages" */ "src/pages/Messages/Send.vue");

let messages = {
  path: "/messages",
  component: DashboardLayout,
  redirect: "/messages/list",
  name: "Messages",
  children: [
    {
      path: "list",
      name: "Message List",
      components: { default: MessageList }
    },
    {
      path: "send",
      name: "Message List",
      components: { default: MessageSend }
    }

  ]
};
 
const LateFeeList = () => import("src/pages/LateFee/List.vue");
let latefee = {
  path: "/latefee",
  component: DashboardLayout,
  redirect: "/latefee/list",
  name: "No Show Fee",
  children: [
    {
      path: "list",
      name: "No Show Fee List",
      components: { default: LateFeeList }
    }
  ]
};

const WhatsappGroupTableList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/WhatsappGroup/TableList.vue");
const WhatsappGroupList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/WhatsappGroup/List.vue");
const WhatsappGroupEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/WhatsappGroup/Edit.vue");

let whatsappGroups = {
  path: "/whatsappgroup",
  component: DashboardLayout,
  redirect: "/whatsappgroup/list",
  name: "WhatsappGroup",
  children: [
    {
      path: "list",
      name: "Whatsapp Group List",
      components: { default: WhatsappGroupList}
    },
    {
      path: "list-table",
      name: "Whatsapp Group List Table",
      components: { default: WhatsappGroupTableList }
    },
    {
      path: "edit",
      name: "Edit Whatsapp Group",
      components: { default: WhatsappGroupEdit }
    },
    {
      path: "add",
      name: "Add Whatsapp Group",
      components: { default: WhatsappGroupEdit }
    },
  ]
};

const EventScheduleList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/EventSchedule/List.vue");
const EventScheduleEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/EventSchedule/Edit.vue");

let eventSchedule = {
  path: "/eventschedule",
  component: DashboardLayout,
  redirect: "/eventschedule/list",
  name: "WhatsappGroup",
  children: [
    {
      path: "list",
      name: "Event Schedule List",
      components: { default: EventScheduleList}
    },
    {
      path: "edit",
      name: "Edit Event Schedule",
      components: { default: EventScheduleEdit }
    },
    {
      path: "add",
      name: "Add Event Schedule",
      components: { default: EventScheduleEdit }
    },
  ]
};

const CreditsBundlesList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/CreditsBundles/List.vue");
const CreditsBundlesEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/CreditsBundles/Edit.vue");

let creditsBundles = {
  path: "/creditsbundles",
  component: DashboardLayout,
  redirect: "/creditsbundles/list",
  name: "CreditsBundles",
  children: [
    {
      path: "list",
      name: "Credits Bundles List",
      components: { default: CreditsBundlesList }
    },
    {
      path: "edit",
      name: "Edit Credits Bundles",
      components: { default: CreditsBundlesEdit }
    },
    {
      path: "add",
      name: "Add Credits Bundles",
      components: { default: CreditsBundlesEdit }
    },
  ]
};

const CreditsTransactionsList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/CreditsTransactions/List.vue");

let creditsTransactions = {
  path: "/creditstransactions",
  component: DashboardLayout,
  redirect: "/creditstransactions/list",
  name: "CreditsTransactions",
  children: [
    {
      path: "list",
      name: "Credits Transactions List",
      components: { default: CreditsTransactionsList }
    }
  ]
};

const AutoNotificationsList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/AutoNotifications/List.vue");

let autoNotifications = {
  path: "/autonotifications",
  component: DashboardLayout,
  redirect: "/autonotifications/list",
  name: "AutoNotifications",
  children: [
    {
      path: "list",
      name: "Auto Notifications List",
      components: { default: AutoNotificationsList }
    }
  ]
};

const CmsPagesList = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/CMS/List.vue");
const CmsPagesEdit = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/CMS/Edit.vue");
const CmsPagesPreview = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/CMS/Preview.vue");

let cmsPages = {
  path: "/cms",
  component: DashboardLayout,
  redirect: "/cms/list",
  name: "CMS Pages",
  children: [
    {
      path: "list",
      name: "CMS Pages List",
      components: { default: CmsPagesList }
    },
    {
      path: "edit",
      name: "Edit CMS Page",
      components: { default: CmsPagesEdit }
    },
    {
      path: "preview",
      name: "CMS Page Preview",
      components: { default: CmsPagesPreview }
    },
    {
      path: "add",
      name: "Add CMS Page",
      components: { default: CmsPagesEdit }
    }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/login",
    name: "Authentication"
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  authPages,
  bookings,
  events,
  users,
  vaccinations,
  hostApplications,
  city,
  sports,
  eventOrganizer,
  passes,
  images,
  latefee,
  messages,
  whatsappGroups,
  eventSchedule,
  creditsBundles,
  creditsTransactions,
  autoNotifications,
  cmsPages,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard layout",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard }
      },
      {
        path: "calendar",
        name: "Calendar",
        components: { default: Calendar }
      },
      {
        path: "charts",
        name: "Charts",
        components: { default: Charts }
      },
      {
        path: "widgets",
        name: "Widgets",
        components: { default: Widgets }
      }
    ]
  },
  contactMessages,
  supportV2,
  eventChat,
  {
    path: "/cms/:slug",
    name: "CMS Public Page",
    component: PublicCmsPage,
    meta: {
      public: true
    }
  },
  { path: "*", component: NotFound }
];

export default routes;
